import crm from './crm';

const caminho = '/webhook'
export const WebhooksService = {
    buscar: (filtros=null) => crm.get(caminho, { params: filtros }),
    salvar: (webhook: object) => crm.post(caminho, webhook),
    atualizar: (id: number, webhook: object) => crm.put(`${caminho}/${id}`, webhook),
    excluir: (id: number) => crm.delete(`${caminho}/${id}`)
}